import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Link, Redirect } from "react-router";

import { FacebookProvider, Comments } from "react-facebook";
import { get } from "../../common/article/actions";
import { setLocation } from "../../common/app/actions";

import moment from "moment";
moment.locale("pl");

import NewArticles from "./NewArticles";

import { ShareButtons, ShareCounts, generateShareIcon } from "react-share";

const {
  FacebookShareButton,
  GooglePlusShareButton,
  TwitterShareButton,
  PinterestShareButton
} = ShareButtons;

import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap";

const isBrowser = typeof window !== "undefined";

class Single extends React.Component {
  constructor() {
    super();

    this.state = {
      href: "",
      url: ""
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.setState({
      url: location.href
    });
    this.getArticle();
  }

  getArticle = async () => {
    const { get, params, setLocation, location } = this.props;

    const slug = params.slug;
    const rs = await get({ slug });
    if (rs && rs.status === 404) {
      this.redirect("/404");
      let loc = location;
      loc.pathname = "/404";
      setLocation(loc);
    }
  };

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  render() {
    const { location, params, map, apiHost } = this.props;

    const slug = params.slug;
    const obj = map.get(slug);

    const blogImage =
      obj && `${apiHost}/v1/article/image/${obj.get("imageFileUid")}`;
    const blogTitle = obj && obj.get("title");
    const blogImageAlt = obj && obj.get("imageAlt");
    const blogContent = obj && obj.get("mainDesc");
    const author = obj && obj.get("author");
    const tag = obj && obj.get("tag");
    const date = obj && moment(obj.get("addedAt"));

    const seoTitle = blogTitle;
    const seoDescription = obj && obj.getIn(["seoDesc"]);
    const seoImage = blogImage;

    return (
      <div className="blog-page">
        <Helmet
          title={seoTitle}
          description={seoDescription}
          meta={[
            { name: "description", content: seoDescription },
            { property: "og:type", content: "website" },
            { property: "og:title", content: seoTitle },
            { property: "og:description", content: seoDescription },
            { property: "og:image", content: seoImage }
          ]}
        />

        <div className="blog-single-section">
          <div className="width-wrapper">
            <Container>
              <Row>
                <Col className="blog-item" xs="12" lg="8">
                  <div className="item-wrapper">
                    <Row>
                      <Col xs="12">
                        <img
                          className="blog-image"
                          src={blogImage}
                          alt={blogImageAlt}
                        />
                      </Col>
                    </Row>
                    <Row className="header flex-items-xs-center">
                      <Col xs="12" lg="1">
                        <div className="date">
                          <div className="number">{date && date.date()}</div>
                          <div className="month">
                            {date && date.format("MMM")}
                          </div>
                        </div>
                      </Col>
                      <Col xs="10" lg="9">
                        <h1 className="blog-title">{blogTitle}</h1>
                        <div className="blog-meta">
                          <span>{author}</span>
                          <span>|</span>
                          <span>{tag}</span>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs="12">
                        <div className="separator" />
                      </Col>
                    </Row>
                    <Row className="flex-items-xs-center">
                      <Col xs="10">
                        <div
                          className="blog-content"
                          dangerouslySetInnerHTML={{ __html: blogContent }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="text-xs-right" xs="12">
                        <div className="separator" />
                        <div className="socials">
                          <FacebookShareButton
                            url={this.state.url}
                            title={blogTitle}
                          >
                            <div className="first share-button">
                              <i className="fa fa-fw fa-facebook" />
                            </div>
                          </FacebookShareButton>
                          <GooglePlusShareButton url={this.state.url}>
                            <div className="share-button">
                              <i className="fa fa-fw fa-google-plus" />
                            </div>
                          </GooglePlusShareButton>
                          <TwitterShareButton url={this.state.url}>
                            <div className="last share-button">
                              <i className="fa fa-fw fa-twitter" />
                            </div>
                          </TwitterShareButton>
                        </div>
                      </Col>
                    </Row>
                    <Row className="flex-items-xs-center">
                      <Col id="comments" xs="10">
                        {isBrowser && (
                          <FacebookProvider
                            appId="343881472739290"
                            language="pl_PL"
                          >
                            <Comments width="100%" />
                          </FacebookProvider>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col className="text-xs-center" xs="12" lg="4">
                  <NewArticles />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

Single.contextTypes = {
  router: React.PropTypes.object.isRequired
};

export default connect(
  state => ({
    apiHost: state.config.apiHost,
    map: state.article.map
  }),
  { get, setLocation }
)(Single);



/** WEBPACK FOOTER **
 ** ./src/browser/blog/Single.js
 **/